import React, { useState } from "react";

import useRequest from 'hooks/useRequest';

import gota from 'assets/images/gota.png';

import Spinner from 'react-bootstrap/Spinner';

import "./styles.scss";

const SpinnerAbsa = ({ children }) => {
    const {
        loadingSpinner
    } = useRequest();
    
    return <div id="spinner-container" className={loadingSpinner ? 'spinner-container show' : 'spinner-container hide'}>
        <Spinner animation="border" role="status">
        </Spinner>
        <img src={gota} alt="gota" />
    </div>
}

export default SpinnerAbsa;














